// api.js — MODULES 6+7: Public API (window.pb)
//
// Module 6 — identify({ id, email, first_name, last_name, company })
//   Calls posthog.identify, _hsq.push(['identify']), Reo.identify.
//
// Module 7 — trackPageview({ title, breadcrumb })
//   Fires a PostHog 'virtual_pageview' event used by SPAs / docs sites
//   to track navigation that doesn't trigger a full page reload.

import { LOG, dbg } from './config.js';

try {
  window.pb = {

    version: _pbVersion,

    // Module 6
    identify: function(user) {
      try {
        if (!user) { return; }
        var id          = user.id          || '';
        var email       = user.email       || '';
        var first_name  = user.first_name  || '';
        var last_name   = user.last_name   || '';
        var company     = user.company     || '';
        var source_app  = user.source_app  || '';

        if (window.posthog) {
          window.posthog.identify(id, {
            email:       email,
            first_name:  first_name,
            last_name:   last_name,
            company:     company,
            source_app:  source_app
          });
        }

        // HubSpot tracking pixel identification
        if (window._hsq) {
          window._hsq.push(['identify', { email: email }]);
        }

        // Reo.dev revenue intelligence
        if (window.Reo && email) {
          window.Reo.identify({ email: email });
        }

        dbg('identify', id);
      } catch (e) {
        console.error(LOG, 'identify error', e);
      }
    },

    // Module 7
    trackPageview: function(opts) {
      try {
        opts = opts || {};
        if (window.posthog) {
          window.posthog.capture('virtual_pageview', {
            $title:             opts.title      || document.title,
            content_breadcrumb: opts.breadcrumb || ''
          });
        }
        dbg('trackPageview', opts.title);
      } catch (e) {
        console.error(LOG, 'trackPageview error', e);
      }
    }

  };

  dbg('API ready');
} catch (e) {
  console.error(LOG, 'API init error', e);
}
